import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatTableModule } from '@angular/material/table'
import { RouterModule } from '@angular/router'
import { PipesModule } from '@mmx/pipes'
import { DirectivesModule } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { BreadcrumbModule } from '../breadcrumb'
import { CopyTextModule } from '../copy-text'
import { InsuranceDialogModule } from '../insurance-dialog'
import { InsurancesCardComponent } from './insurances-card.component'

const dialogs = []

@NgModule({
  declarations: [
    InsurancesCardComponent,
    ...dialogs,
  ],
  imports: [
    BreadcrumbModule,
    CommonModule,
    CopyTextModule,
    DirectivesModule,
    FlexLayoutModule,
    InsuranceDialogModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatProgressBarModule,
    MatTableModule,
    PipesModule,
    RouterModule,
    TranslateModule,
  ],
  exports: [InsurancesCardComponent],
})
export class InsurancesCardModule {}
